// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2N-pj","requiredAsterisk":"Info_requiredAsterisk__2R3oQ"};